export default __webpack_public_path__ + "static/about_animation-ba8d74766d6ca6264bc9dcd3ef623b38.mp4";